
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { CreateAttributesPopupComponent } from '../../create-attributes-popup/create-attributes-popup.component';

export interface JeevObjectsEditData {
  editData: any;
}

@Component({
    selector: 'app-jeev-objects-popup',
    templateUrl: './jeev-objects-popup.component.html',
    styleUrls: ['./jeev-objects-popup.component.scss'],
    standalone: false
})

/* Author- Renuka chama
  16/03/2026
  For creation of  JSuite object popup screen */
export class JeevObjectsPopupComponent implements OnInit {

  FormValid: UntypedFormGroup;
  formValidCheckbox: UntypedFormGroup;

  backgroundColorButton;
  buttonName = "Save";
  isEditMode = false;

  isCheckboxSelected = false;
  showCreateAnother = true;

  objectTypeList: any[] = [];
  lifecycleList: any[] = [];
  jsuiteObjects: any = {
    objectName: '',
    objectType: '',
    lifecycle: '',
    attributes: ''
  };

  validation_messages = {
    objectName: [
      { type: 'required', message: 'Object Name is required' }
    ],
    objectType: [
      { type: 'required', message: 'Object Type is required' }
    ],
      attributes: [
        { type: 'required', message: 'Attributes is required' }
      ]
    };

  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private validation: validationmethod,
    private localstorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private errormessage: ErrorMessages,
    public dialogRef: MatDialogRef<JeevObjectsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: JeevObjectsEditData
  ) { }

  ngOnInit(): void {

    this.backgroundColorButton = this.localstorage.getSettings('ColorA');

    this.formValidations();
    this.formValidationsCheckbox();

    this.loadObjectTypes();
this.loadLifecycles();

if (this.data?.editData) {
  this.buttonName = "Update";
  this.showCreateAnother = false;
  this.isEditMode = true;
}

  }

  formValidations() {
    this.FormValid = this.fb.group({
      objectName: new UntypedFormControl('', Validators.required),
      objectType: new UntypedFormControl('', Validators.required),
      lifecycle: new UntypedFormControl(''),
      attributes: new UntypedFormControl('', Validators.required)
    });
  }

  formValidationsCheckbox() {
    this.formValidCheckbox = this.fb.group({
      isCheckboxSelected: new UntypedFormControl(false)
    });
  }

  loadObjectTypes() {

    this.commonService.getlookupVauleByLookUpType("Object Type").subscribe((res: any) => {
      console.log("Lookup Response", res);
      if (!res.error) {
  this.objectTypeList = res;
}
    });

  }

  loadLifecycles(){

  this.commonService.getAllLifecycle().subscribe((res:any)=>{


   if(!res.error){
      this.lifecycleList = res.data;
      // populate edit after dropdown loads
      if (this.data?.editData) {
        this.populateEditData(this.data.editData);
      }
    }
  });

}

  onObjectTypeChange(value) {
    this.jsuiteObjects.objectType = value;
  }

  openAttributePopup(data) {

    let dialogRef = this.dialog.open(CreateAttributesPopupComponent, {
      width: "80%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "90%",
      disableClose: true,
      data: {
        existingAttributesData: this.jsuiteObjects.attributes
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.jsuiteObjects.attributes = result;
        this.FormValid.patchValue({
          attributes: result
        });
      }

    });

  }

  saveMethod() {

    if (this.FormValid.invalid) {

      this.validation.validateAllFormFields(this.FormValid);

      this.snackbar.open("All mandatory fields must be filled", "OK", {
        duration: 4000
      });

      return;
    }

    let requestData = {
      objectId: this.jsuiteObjects.objectId,
      objectName: this.jsuiteObjects.objectName,
      objectType: this.jsuiteObjects.objectType,
      lifecycle: this.jsuiteObjects.lifecycle,
      attributes: this.jsuiteObjects.attributes
    };

    this.spinner.start();

    this.commonService.createJeevObject(requestData).subscribe(res => {

      this.spinner.stop();

      if (res.error) {
        this.snackbar.open(res.statusMessage, "OK", { duration: 4000 });
        return;
      }

      let message = this.buttonName === 'Update'
        ? "Successfully record is updated"
        : "Successfully record is inserted";

      this.snackbar.open(message, "OK", { duration: 4000 });

      if (this.isCheckboxSelected && this.buttonName === 'Save') {

        this.FormValid.reset();
        this.jsuiteObjects = {};
        return;

      } else {

        this.dialogRef.close(true);

      }

    }, err => {

      this.spinner.stop();
      this.snackbar.open("Failed to save record", "OK", { duration: 4000 });

    });

  }

  populateEditData(data) {

    this.jsuiteObjects = {
    objectId: data.objectId,
    objectName: data.objectName,
    objectType: data.objectType,
    lifecycle: Number(data.lifecycle),
    attributes: data.attributes
  };

  this.FormValid.patchValue({
    objectName: data.objectName,
    objectType: data.objectType,
    lifecycle: Number(data.lifecycle),
    attributes: data.attributes
  });
  }

  cancel() {
    this.dialogRef.close();
  }

}